(function ($) {
    // Vars
    var $html = $('html');
    var $body = $('body');
    var $window = $(window);
    var $header = $('header');

    $(document).ready(function () {
        // Functions
        navOnScroll();
        sliderSetup();
        featureProductSliderSetup();
        contentBlockSliderSetup();

        // Change the responsive showing the slider from grid
        if ($(window).width() <= 991) {
            featureNewsBlockSliderSetup();
        }

        scFeatureNewsBlockSlider();
        scSlideShowGallery();
        scSimilarResourceSlider();
        landingPageAnimation();

        // Sticky JS
        var sticky = new Sticky('[data-sticky]');

        // Bootstrap Select
        $('select').selectpicker();

        /* 
            Disclaimer Popup Cookie
            Popup not viewed on first page load. Set to false.
            Once viewed, session cookie is update to view. Set to true.
        */
        var viewSessionStatus = sessionStorage.getItem('isNewSession');
        if (viewSessionStatus != null) {
            // the user has been to the website before
        } else {
            disclaimerPopup();
            sessionStorage.setItem('isNewSession', 'true');
        }
        
        //Force Close Disclaimer Popup Block - after 30 seconds
        setTimeout(function () {
            disclaimerPopupClose();
        }, 30000); // for 30 second delay 
    });

    // Onclick Events
    $body
        .on('click', '.js-mobile-trigger', function (e) {
            e.preventDefault();
            var $trigger = $(this);
            if ($trigger.hasClass('active')) {
                $trigger.removeClass('active');
                $body.removeClass('hamburger-menu-active');
                $html.removeClass('no-scroll');
            }
            else {
                $trigger.addClass('active');
                $body.addClass('hamburger-menu-active');
                $html.addClass('no-scroll');
            }
        })
        .on('click', '.js-footer-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.footer-accordion');
            var $accordionContent = $accordion.find('.footer-accordion__content');
            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $accordionContent.slideUp(350);
            } else {
                $accordion.addClass('active');
                $accordionContent.slideDown(350);
            }
        })
        .on('click', '.js-accordion-trigger', function (e) {
            if ($(this).hasClass('.has-link')) {} else {
                e.preventDefault();
                var $accordion = $(this).closest('.accordion');
                var $accordionContent = $accordion.find('.accordion__content');

                if ($accordion.hasClass('active')) {
                    $accordion.removeClass('active');
                    $accordionContent.slideUp(350);
                } else {
                    $accordion.addClass('active');
                    $accordionContent.slideDown(350);
                }
            }
        })
        .on('click', '.js-accordion-trigger', function (e) {
            if ($(this).hasClass('.has-link')) {} else {
                e.preventDefault();
                var $accordion = $(this).closest('.aside-accordion');
                var $accordionContent = $accordion.find('.aside-accordion__content');

                if ($accordion.hasClass('active')) {
                    $accordion.removeClass('active');
                    $accordionContent.slideUp(350);
                } else {
                    $accordion.addClass('active');
                    $accordionContent.slideDown(350);
                }
            }
        })
        .on('click', '.js-standard-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.standard-accordion');
            var $accordionContent = $accordion.find('.standard-accordion__content');
            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $accordionContent.slideUp(350);
            } else {
                $accordion.addClass('active');
                $accordionContent.slideDown(350);
            }
        })
        .on('click', '.js-scroll-to-id', function (e) {
            e.preventDefault();

            // target element id
            var id = $(this).attr('href');

            // Navigation Size
            var navigation = $('body').find('header.navigation');
            var navigationHeight = navigation.outerHeight();

            // target element
            var $id = $(id);
            if ($id.length === 0) {
                return;
            }            

            // top position relative to the document
            var pos = $id.offset().top - navigationHeight;
            

            // animated top scrolling
            $('body, html').animate({ scrollTop: pos }, 1000);
        })
        .on('click', '.js-disclaimer-popup-block', function (e) {
            $disclaimerPopupBlock = $body.find('.disclaimer-popup-block');
            $disclaimerPopupBlockInner = $disclaimerPopupBlock.find('.disclaimer-popup-block__inner');
            $disclaimerPopupBlockAlternateButton = $disclaimerPopupBlockInner.find('a.js-disclaimer-popup-block');

            if ($(this).hasClass('js-open')) {
                $disclaimerPopupBlock.removeClass('js-open');
                $(this).removeClass('js-open');
                $disclaimerPopupBlockAlternateButton.removeClass('js-open');
            } else {
                $disclaimerPopupBlock.addClass('js-open');
                $(this).addClass('js-open');
                $disclaimerPopupBlockAlternateButton.addClass('js-open');
            }
        })
    ;

    // Resize Functions
    var resizeThreshold;
    $(window).on('resize', function (event) {        
        if (resizeThreshold) {
            clearTimeout(resizeThreshold);
        }

        resizeThreshold = setTimeout(function () {
            setTimeout(function () {
                // Functions
                sliderSetup();
                featureProductSliderSetup();
                contentBlockSliderSetup();

                // Change the responsive showing the slider from grid
                if ($(window).width() <= 991) {
                    featureNewsBlockSliderSetup();
                }
                else {
                    if ($('.feature-news-block-slider .slider').hasClass('slick-initialized')) {
                        $('.feature-news-block-slider .slider').slick('unslick');
                    }
                }

                scFeatureNewsBlockSlider();
                scSlideShowGallery();
                scSimilarResourceSlider();
            }, 100);
        }, 200);
    });

    // Custom label/index for quiz form
    $('form .question').each(function(index){
        var pageTotal = $('form .question').length;
        if( pageTotal > 1 ) {
            $(this).children("legend").prepend('<span class="question_tagline">Question ' + ( index + 1 ) + ' of '+ (pageTotal) +'</span>');
        } 
    });

    // Quiz form - Disable submit before question is answered
    $('form.quiz-form').on('change', function(e) {
        if( jQuery('.gfield_contains_required:visible input[type="radio"]:checked').length > 0) {
            $(this).find('input[type="submit"]').removeClass('disabled button-disabled').removeAttr('disabled');
            
        } else {
            $(this).find('input[type="submit"]').addClass('disabled button-disabled').attr('disabled', 'disabled');
        }
    }).trigger('change');
})(jQuery);
